/**
 * Created by 九次方前端研发部-朱润亚<zry@jusfoun.com> on 2018/6/26.
 */
import ChartServer from '9cf-chart'

ChartServer.setConfig({url: 'https://img.9cfcf.com'})



// WEBPACK FOOTER //
// ./src/assets/js/config.js